export class AuthConstants {
    public static readonly WITH_PROGRESS = "with progress";
    public static readonly ACCESS_TOKEN = "accessToken";
    public static readonly REFRESH_TOKEN = "refreshToken";
    public static readonly LOGIN_DICES_REWARD = "loginDiceRewards";
    public static readonly FACEBOOK_AUTH_CHECKED = "facebookAuthChecked";
}